module.exports = __webpack_public_path__ + "img/imagen7.0fbbe2a7.png";